import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRouter } from 'vue-router'
import { authApi } from '@/shared/api'
import { removeToken, showErrorMessage } from '@/shared/utils'
import { useUser } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const { setIsAuth } = useUser()

const handleLogout = async (): Promise<void> => {
  const [error] = await authApi.logout()

  if (error) {
    showErrorMessage(error)

    return
  }

  removeToken()

  setIsAuth(false)

  router.push({ name: 'AuthPage' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "logout",
    onClick: handleLogout
  }, "Выйти"))
}
}

})